

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios';
// import qs from 'qs'
import {Http} from './untils/http.js';//接口处理
import '@/untils/filter'; //过滤器函数
import 'babel-polyfill';
import 'url-search-params-polyfill';
import "classlist-polyfill";
import promise from 'es6-promise';
promise.polyfill();
import 'amfe-flexible';
import 'vant/lib/index.css';
// import './assets/scss/global.scss';
import './assets/scss/home.scss';
import './assets/scss/tech.scss';
import Mui from 'vue-awesome-mui';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);
import {
  Rate,
  Row,
  Col,
  Icon,
  NavBar,
  Popup,
  Tab,
  Tabs,
  Form,
  Field,
  Divider,
  Cell,
  Switch,
  Checkbox,
  CheckboxGroup,
  CellGroup,
  Button,
  Uploader,
  Picker,
  DatetimePicker,
  DropdownMenu,
  DropdownItem,
  Tabbar,
  TabbarItem,
  Lazyload,
  Toast,
  List,
  Swipe, 
  SwipeItem,
  Step, 
  Steps,
  Radio,
  RadioGroup,
  Area,
  Dialog,
  Loading,
  Image as VanImage
} from 'vant';
// const middleware = require('middleware-js')();
// middleware.use((req, res, next) => {
//   //...
//   next();
// });
// middleware.handle(req, res);
// import vConsole from './untils/vconsole.js';
// Vue.use(vConsole);

Vue.use(Rate)
Vue.use(Row);
Vue.use(Col);
Vue.use(VanImage);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Field);
Vue.use(Divider);
Vue.use(Cell);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Mui);
Vue.use(List);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Area);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Lazyload, {
  preLoad: 1.3,
  // error: require('@/assets/images/goods_default.png'),
  // loading: require('@/assets/images/goods_default.png'),
  attempt: 1,
  // listenEvents: ['scroll'],
  lazyComponent: true
});
Vue.config.productionTip = false;
Vue.prototype.$http = Http;
// Vue.prototype.$axios = axios;
// Vue.prototype.$qs = qs;
// window.addEventListener('popstate', function() {
//   history.pushState(null, null, document.URL)
//  })

router.afterEach(() => {
	window.scrollTo(0,0);
});
// 强制合并代码
// git pull origin master --allow-unrelated-histories
new Vue({
  router,
  store,
  // scrollBehavior: () => {
  //   history.pushState(null, null, document.URL)
  // },
  render: h => h(App)
}).$mount('#app')
// <!-- joyveb@com123 -->